import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { handleFetchWebhookRequests } from '@/pages/Integration/store/Integration';
import { Button, Card, CardContent, CircularProgress, Tooltip } from '@mui/material';
import { hideProgressSpinner, showProgressSpinner } from "@/helpers/ProgressSpinnerService";
import ns from '@/helpers/NotificationService';
import { NestedAccordionGrid, Header, NestedGridDataModel, Row } from "@/components/NestedAccordionGrid";
import { FaRedo } from "react-icons/fa";
import { formatDateTime } from "../../helpers/Utils";
import LoadingButton from "@mui/lab/LoadingButton";

interface Props {
    handleFetchWebhookRequests_d: (onCompletedCallback: (res: any) => void) => void,
    loading: boolean,
    settings: any,
    integration: any
}

const WebhookRequestList: React.FC<Props> = (props) => {
    const {
        handleFetchWebhookRequests_d,
        loading,
        settings,
        integration,
        integration: { webhookRequests }
    } = props;

    const [webhookRequestsModel, setWebhookRequestsModel] = useState<NestedGridDataModel>();
    const [reloading, setReloading] = useState<boolean>(false);

    useEffect(() => {
        reload();
    }, [])

    useEffect(() => {
        resetWebhookRequests();
    }, [webhookRequests, reloading])

    const resetWebhookRequests = () => {
        if (webhookRequests) renderRequestsTable();
    }

    const reload = (withLoading = true) => {
        setReloading(true);
        if (withLoading) showProgressSpinner({ description: 'Loading webhook requests...' });
        handleFetchWebhookRequests_d((res) => {
            if (!res.success) {
                ns.error('Failed to load the webhook requests');
            }
            hideProgressSpinner();
            setReloading(false);
        })
    }

    const renderRequestsTable = () => {
        let headers: Header[] = [
            { title: "User", align: "inherit" },
            { title: "Unique Reference", align: "inherit" },
            { title: "Type", align: "inherit" },
            { title: "Processing Status", align: "inherit" },
            { title: "Created Date", align: "inherit" },
            { title: "Processed Date", align: "inherit" },
        ];

        let rows: Row[] = webhookRequests.map(request => {
            return {
                id: request.id,
                cells: [
                    { text: request.username, align: "inherit" },
                    { text: request.uniqueReference, align: "inherit" },
                    { text: request.data?.type, align: "inherit" },
                    { text: request.processingStatus.toString(), align: "inherit" },
                    { text: formatDateTime(request.createdAt, 'yyyy/MM/dd HH:mm'), align: "inherit" },
                    { text: request.processedAt ? formatDateTime(request.processedAt, 'yyyy/MM/dd HH:mm') : 'N/A', align: "inherit" },
                ],
                //actionButtons: [
                //    <Tooltip title={`Generate Integration Token`} >
                //        <Button onClick={() => generateToken(user.id)} size="small" className="btn-primary mx-1 rounded-sm shadow-none hover-scale-sm d-40 border-0 p-0 d-inline-flex align-items-center justify-content-center text-capitalize">
                //            {generatingTokens?.find(x => x === user.id) ? <CircularProgress size={20} /> : <AiOutlineReload />}
                //        </Button>
                //    </Tooltip>
                //]
            }
        });

        setWebhookRequestsModel({
            headers: headers,
            rows: rows,
            headerButtons: [
                <Tooltip title="Refresh Table" placement="left">
                    <LoadingButton disabled={reloading} loading={reloading} onClick={() => reload(false)} variant="text" className={"btn-outline-primary d-flex align-items-center justify-content-center d-40 mr-2 p-0 rounded-pill text-capitalize"}>
                        <FaRedo />
                    </LoadingButton>
                </Tooltip>
            ]
        });
    }

    return <Card className='card-transparent'>
        <CardContent className='pt-0'>
            <NestedAccordionGrid dataModel={webhookRequestsModel} showTopDivider={false} />
        </CardContent>
    </Card>
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleFetchWebhookRequests_d: (onCompletedCallback: (res: any) => void) => dispatch(handleFetchWebhookRequests(onCompletedCallback)),
    }
}

const mapStateToProps = (state: any) => ({
    loading: state.progressSpinner.loading,
    settings: state.settings.settings,
    integration: state.integration
})

export default connect(mapStateToProps, mapDispatchToProps)(WebhookRequestList);